import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/*
 * Archetype B shell — filter bar above a table, inside one bordered panel.
 * Extracted because Masterlist, For Approval, Subscriptions, Banned Words and
 * Reports were each carrying their own copy of the same three class strings.
 *
 * Panel: bg-white, 1px neutral-200, radius 6, no shadow. Grouping is hairlines
 * and tone — the white-card-on-grey field is abandoned.
 */
function ListPanel({ filters, summary, pagination, children, className }) {
  return (
    <section
      className={cn(
        'bg-white border border-neutral-200 rounded-md h-full flex flex-col overflow-hidden',
        className,
      )}
    >
      {(filters || summary) && (
        <div className="px-5 py-4 border-b border-neutral-200 flex flex-wrap items-center gap-3">
          {filters}
          {summary && (
            <div className="ml-auto text-xs text-neutral-500 tabular-nums">
              {summary}
            </div>
          )}
        </div>
      )}
      <div className="flex-1 flex flex-col min-h-[65vh]">{children}</div>
      {pagination && (
        <div className="px-5 py-3 border-t border-neutral-200">
          {pagination}
        </div>
      )}
    </section>
  );
}

ListPanel.defaultProps = {
  filters: null,
  summary: null,
  pagination: null,
  className: '',
};

ListPanel.propTypes = {
  filters: PropTypes.node,
  summary: PropTypes.node,
  pagination: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ListPanel;
